import StockAdjustmentBillWise from './reports/stockadjustmentbillwise';
import PurchaseBillWise from './reports/purchasebillwise';
import PurchaseItemWise from './reports/purchaseitemwise';
import SalesBillWise from './reports/salesbillwise';
import SalesBillWiseIP from './reports/salesbillwiseip';
import SalesSectionWise from './reports/salessectionwise';
import SalesDoctorWise from './reports/salesdoctorwise';
import SalesReturnBillWise from './reports/salesreturnbillwise';
import OpeningStockBillWise from './reports/openingstockbillwise';
import StockConsumptionBillWise from './reports/stockconsumptionbillwise';
import SalesBillItemWise from './reports/salesbillitemwise';
import SalesLedger from './reports/salesledger';
import ReorderLevel from './reports/reorderlevel';
import StockLedger from './reports/stockledger';
import ExpiryReport from './reports/expiryreport';
import DeadStockReport from './reports/deadstockreport';
import PharmacyCollectionReport from './reports/PharmacyCollectionReport';
import PurchaseLedger from './reports/purchaseledger';
import PurchaseReturnReport from './reports/purchasereturnreport';
import FOCItemsReport from './reports/focitemsreport';
import ItemMovingReport from './reports/itemmovingreport';
import SalesPatientWisePage from './reports/salespatientwise';

/**
 * Keys match TabbedLayout tab paths: `${categoryId}${report.id}` (e.g. salesbill-wise).
 */
export const REPORT_INLINE_COMPONENTS = {
  'salesbill-wise': SalesBillWise,
  'salesbill-wise-ip': SalesBillWiseIP,
  'salessection-wise': SalesSectionWise,
  'salesitem-wise': SalesBillItemWise,
  'salesledger': SalesLedger,
  'salespatient-wise': SalesPatientWisePage,
  'salesdoctor-wise': SalesDoctorWise,
  'salesitem-moving': ItemMovingReport,
  'purchasebill-wise': PurchaseBillWise,
  'purchaseitem-wise': PurchaseItemWise,
  'purchaseledger': PurchaseLedger,
  'purchasereturn-report': PurchaseReturnReport,
  'purchasefoc-items': FOCItemsReport,
  'salesreturnbill-wise': SalesReturnBillWise,
  'openingstockbill-wise': OpeningStockBillWise,
  'stockadjustmentbill-wise': StockAdjustmentBillWise,
  'stockconsumptionbill-wise': StockConsumptionBillWise,
  'stockreorder-level': ReorderLevel,
  'stockledger': StockLedger,
  'stockexpiry-report': ExpiryReport,
  'stockdead-stock': DeadStockReport,
  'pharmacycollection-report': PharmacyCollectionReport,
  'collectionpharmacy-collection': PharmacyCollectionReport,
};

export function getInlineReportComponent(path) {
  return REPORT_INLINE_COMPONENTS[path] ?? null;
}
